<template>
	<vx-card no-shadow card-border>
		<!--  FIRST ROW  -->
		<div class="vx-row">
			<div class="vx-col w-full md:w-1/1">
				<label class="vs-input--label">{{ $t("ListGroup") }}</label>
				<v-select
					v-model="selectedGroup"
					v-validate="'required'"
					name="group"
					:dir="$vs.rtl ? 'rtl' : 'ltr'"
					:clearable="false"
					:options="group_options"
				>
					<template v-slot:no-options="{search, searching}">
						<template v-if="searching">
							{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
						</template>
					</template>
				</v-select>
				<span class="text-danger text-sm" v-show="errors.has('group')">{{ errors.first("group") }}</span>
			</div>
		</div>
		<slot></slot>
	</vx-card>
</template>

<script>
import vSelect from "vue-select";
import moduleGroup from "@/store/group/moduleGroup.js";
import Group from "@/models/Group.js";
import Commons from "@/helpers/commons.js";

export default {
	components: {
		vSelect,
	},
	data() {
		return {
			group: new Group({}),
			selectedGroup: null,
		};
	},
	computed: {
		groups() {
			return this.$store.state.moduleGroup.groups;
		},
		group_options() {
			return Commons.generateSelectOptios(this.$store.state.moduleGroup.groups, "name", "id");
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getGroups() {
			this.openLoading();
			this.$store
				.dispatch("moduleGroup/fetchGroupItems", {})
				.then((res) => {
					this.closeLoading();
					return res;
				})
				.catch((error) => {
					this.closeLoading();
					if (error.status === 722) {
						this.$vs.notify({
							color: "danger",
							title: this.$t("Permissions.RequiredPermissions"),
							text: `${this.$t("Roles.Permissions.NotPermissionsText")} ${error.error}`,
							time: 6000,
							icon: "lock",
						});
					}
					throw new Error(error);
				});
		},
		setSelectedGroup() {
			this.$store.commit("moduleGroup/SET_SELECTED_GROUP", this.group);
		},
	},
	watch: {
		selectedGroup(group) {
			if (group) {
				this.group = this.$store.getters["moduleGroup/getGroupById"](group.value);
				if (this.group !== undefined && this.group.id > 0) {
				}
				this.$emit("changeGroupEmit", this.group);
			}
		},
	},
	created() {
		// register Module Group
		if (!moduleGroup.isRegistered) {
			this.$store.registerModule("moduleGroup", moduleGroup);
			moduleGroup.isRegistered = true;
		}
		this.getGroups();
	},
};
</script>
